import * as React from "react";
import Box from "@mui/material/Box";
import { Route, Routes } from "react-router-dom";
import module from "./index";
import NoMatch from "../../components/NoMatch";
import { AuthProvider } from "@route-planner/context/AuthContext";

const TripsLayout = (props) => {
  const submodules = module.submodules;
  return (
    <AuthProvider>
      <Box sx={{ height: "100%", overflow: "auto" }}>
        <Routes>
          {submodules.map((sub) => (
            <Route
              key={sub.name}
              path={sub.routeProps.path}
              element={<sub.routeProps.component />}
            />
          ))}
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Box>
    </AuthProvider>
  );
};

export default TripsLayout;
